import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Users } from "lucide-react";
import { fmtEur } from "@/admin/adminLabels";

export default function CompatibleLeadsPanel({ leadId }) {
  const [matches, setMatches] = useState(null);
  useEffect(() => {
    if (!leadId) return;
    api.get(`/admin/leads/${leadId}/compatible`).then((r) => setMatches(r.data)).catch(() => setMatches([]));
  }, [leadId]);

  if (matches === null) return null;

  return (
    <div className="rounded-xl border border-[#E2E8F0] bg-sand/40 p-4">
      <div className="flex items-center gap-2">
        <Users className="h-4 w-4 text-turquoise" />
        <p className="text-xs uppercase tracking-wider text-ink font-semibold">Richieste compatibili</p>
      </div>
      <p className="mt-1 text-xs text-ink">Altri lead aperti con destinazione/periodo/budget compatibili — possibile combinazione cabine o gruppo.</p>
      <div className="mt-4 space-y-2">
        {matches.length === 0 && <p className="text-sm text-ink">Nessuna compatibilità individuata al momento.</p>}
        {matches.map((m, i) => (
          <div key={i} data-testid={`compat-${i}`} className="flex items-center justify-between bg-white rounded-lg border border-[#E2E8F0] p-3">
            <div className="min-w-0">
              <p className="text-sm font-medium text-navy truncate">{m.lead.name} · {m.lead.num_participants}p · {fmtEur(m.lead.budget)}</p>
              <p className="text-xs text-ink truncate">{(m.lead.destinations || []).join(" · ") || "—"} · {m.reasons.join(", ")}</p>
            </div>
            <Badge className="bg-navy text-white">{m.match_score}%</Badge>
          </div>
        ))}
      </div>
    </div>
  );
}
